import { EntityType } from "@/queries/folder-entities/types";

export const routePaths = {
  workspaceFolder: (workspaceId: number | string | undefined, folderId: number | string) =>
    `/workspace/${workspaceId}/folder/${folderId}`,
  workspacePrompt: (
    workspaceId: number | string | undefined,
    promptId: number | string,
    versionNumber?: number | string,
  ) =>
    versionNumber
      ? `/workspace/${workspaceId}/prompt/${promptId}/version/${versionNumber}`
      : `/workspace/${workspaceId}/prompt/${promptId}`,
  workspaceWorkflow: (
    workspaceId: number | string | undefined,
    workflowId: number | string,
    versionNumber?: number | string,
  ) =>
    versionNumber
      ? `/workspace/${workspaceId}/workflow/${workflowId}/version/${versionNumber}`
      : `/workspace/${workspaceId}/workflow/${workflowId}`,
  workspaceDataset: (
    workspaceId: number | string | undefined,
    datasetId: number | string,
    versionNumber?: number | string,
  ) =>
    versionNumber
      ? `/workspace/${workspaceId}/dataset-groups/${datasetId}/dataset/${versionNumber}`
      : `/workspace/${workspaceId}/dataset-groups/${datasetId}`,
  workspaceBlueprint: (workspaceId: number | string | undefined, blueprintId: number | string) =>
    `/workspace/${workspaceId}/evaluate/blueprints/${blueprintId}`,
  workspaceAbTest: (workspaceId: number | string | undefined, abTestId: number | string) =>
    `/workspace/${workspaceId}/ab-releases/prompt-release-group/${abTestId}`,
  workspaceInputVariableSet: (
    workspaceId: number | string | undefined,
    inputVariableSetId: number | string,
  ) => `/workspace/${workspaceId}/input-variable-set/${inputVariableSetId}`,
  workspaceSnippet: (
    workspaceId: number | string | undefined,
    snippetId: number | string,
    versionNumber?: number | string,
  ) =>
    versionNumber
      ? `/workspace/${workspaceId}/prompt/${snippetId}/version/${versionNumber}`
      : `/workspace/${workspaceId}/prompt/${snippetId}`,
  workspaceSmartTable: (workspaceId: number | string | undefined, smartTableId: number | string) =>
    `/workspace/${workspaceId}/smart-tables/${smartTableId}`,
  workspaceSkillCollection: (workspaceId: number | string | undefined, skillCollectionId: string) =>
    `/workspace/${workspaceId}/skill-collection/${skillCollectionId}`,
  workspaceTool: (workspaceId: number | string | undefined, toolId: number | string) =>
    `/workspace/${workspaceId}/tool/${toolId}`,
  workspacePlayground: (workspaceId: number | string | undefined, searchQuery = "") =>
    `/workspace/${workspaceId}/playground${searchQuery}`,
  getEntityPath: (
    workspaceId: number | string | undefined,
    type: EntityType,
    id: number | string,
    versionNumber?: number | string,
  ) => {
    switch (type) {
      case EntityType.FOLDER:
        return routePaths.workspaceFolder(workspaceId, id);
      case EntityType.PROMPT:
        return routePaths.workspacePrompt(workspaceId, id, versionNumber);
      case EntityType.WORKFLOW:
        return routePaths.workspaceWorkflow(workspaceId, id, versionNumber);
      case EntityType.DATASET:
        return routePaths.workspaceDataset(workspaceId, id, versionNumber);
      case EntityType.REPORT:
        return routePaths.workspaceBlueprint(workspaceId, id);
      case EntityType.AB_TEST:
        return routePaths.workspaceAbTest(workspaceId, id);
      case EntityType.INPUT_VARIABLE_SET:
        return routePaths.workspaceInputVariableSet(workspaceId, id);
      case EntityType.SNIPPET:
        return routePaths.workspaceSnippet(workspaceId, id, versionNumber);
      case EntityType.SMART_TABLE:
        return routePaths.workspaceSmartTable(workspaceId, id);
      case EntityType.SKILL_COLLECTION:
        return routePaths.workspaceSkillCollection(workspaceId, String(id));
      case EntityType.TOOL:
        return routePaths.workspaceTool(workspaceId, id);
      default:
        return "#";
    }
  },
};
